export enum CommonActionTypes {
    LOADDING = '@@common/LOADDING',
    ALERT = '@@common/ALERT',
    CONFIRM_ALERT = '@@common/CONFIRM',
    SHOW_RIGHT_SIDEBAR = '@@layout/SHOW_RIGHT_SIDEBAR',
    HIDE_RIGHT_SIDEBAR = '@@layout/HIDE_RIGHT_SIDEBAR'
}